import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'
import {gsap} from 'gsap'


let sceneready = false;
const loadingBarElement = document.querySelector('.loading-bar');
const loadingtext = document.querySelector('.loadingtext');
const headingText = document.querySelector('.headingText')
const button = document.querySelector('.btn')
const loadingManager = new THREE.LoadingManager(
    ()=>
    {
        window.setTimeout(() =>
        {
            // Animate overlay
            gsap.to(overlaymaterial.uniforms.uAlpha, { duration: 2, value: 0, delay: 1 })

            // Update loadingBarElement
            loadingBarElement.classList.add('ended')
            loadingBarElement.style.transform = ''

        }, 500)

        window.setTimeout(()=>{
            loadingtext.style.opacity = 0;
            headingText.style.opacity = 1;
            button.style.opacity = 1;
        },1500)

        window.setTimeout(() =>
        {   
            
            sceneready = true

        },2000)

    },

    (itemUrl,itemsloaded,itemsTotal)=>
    {
        const progressRatio=(itemsloaded/itemsTotal);

        loadingBarElement.style.transform = `scaleX(${progressRatio})`
        
    },

    ()=>{
        // console.log('error')
    },

);




const dracoLoader = new DRACOLoader(loadingManager)
dracoLoader.setDecoderPath('draco/')
const gltfLoader = new GLTFLoader(loadingManager)
gltfLoader.setDRACOLoader(dracoLoader)

const canvas = document.querySelector('canvas.webgl')

const scene = new THREE.Scene()


const overlayGeometry = new THREE.PlaneBufferGeometry(2,2,1,1)
const overlaymaterial = new THREE.ShaderMaterial({
    // wireframe: true,
    transparent: true,
    uniforms: {
        uAlpha: {value: 1},
    },
    vertexShader:`
    void main(){
        gl_Position =  vec4(position,1.0);
    }
    `,

    fragmentShader:`
    uniform float uAlpha;
    void main(){
        gl_FragColor = vec4(1.001,0.833,0.22,uAlpha);
    }`
})

const overlay = new THREE.Mesh(overlayGeometry, overlaymaterial);
// overlay.rotation.y=3
scene.add(overlay);



const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{

    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()


    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})




const camera = new THREE.PerspectiveCamera(38, sizes.width / sizes.height, 0.1, 100)
camera.position.set(5, 2, - 5)
scene.add(camera)


// Controls
const controls = new OrbitControls(camera, canvas)
controls.minDistance = 5.5;
controls.maxDistance = 10.5;
controls.enableDamping = true
controls.dampingFactor = 0.03;
controls.minPolarAngle = 0; // radians
controls.maxPolarAngle = (Math.PI)/2;
controls.minAzimuthAngle = 0 


const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true
})

renderer.outputEncoding = THREE.sRGBEncoding
renderer.toneMapping = THREE.ReinhardToneMapping
renderer.toneMappingExposure = 3

renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))




gltfLoader.load(
    '/models/FlightHelmet/glTF/background2.gltf',
    (gltf) =>
    {
        
        gltf.scene.scale.set(2, 2, 2)
        gltf.scene.position.set(0, - 1.9, 0)
        gltf.scene.rotation.y = Math.PI * 0.55
        scene.add(gltf.scene)
        
    }
)
    
let foxMixer = null
gltfLoader.load(
    '/models/FlightHelmet/glTF/charcater.gltf',
    (gltf2) =>
    {

        gltf2.scene.scale.set(2, 2, 2)
        gltf2.scene.position.set(0, - 1.9, 0)
        gltf2.scene.rotation.y = Math.PI * 0.55
        scene.add(gltf2.scene)
        foxMixer = new THREE.AnimationMixer(gltf2.scene)
        const foxAction = foxMixer.clipAction(gltf2.animations[0])
        foxAction.play()

    }
)



const raycaster = new THREE.Raycaster()

const points=[
    {
        position: new THREE.Vector3(1.55, 0.3, - 0.6),
        element: document.querySelector('.point-0')
    },

    {
        position: new THREE.Vector3(-1.8, -1.8,  1.6),
        element: document.querySelector('.point-2')
    },
    {
        position: new THREE.Vector3(1.6, -1.3,  -0.7),
        element: document.querySelector('.point-1')
    },
    {
        position: new THREE.Vector3(1.4, -1.2, 2.1),
        element: document.querySelector('.point-3')
    },
    {
        position: new THREE.Vector3(-1.3, 0.3,  1.6),
        element: document.querySelector('.point-4')
    },
]


// const axesHelper = new THREE.AxesHelper( 5 );
// scene.add( axesHelper );





const clock = new THREE.Clock()
let previousTime = 0

const animate = () =>
{
    const elapsedTime = clock.getElapsedTime()
    const deltaTime = elapsedTime - previousTime
    previousTime = elapsedTime
    
    
    controls.update()


    if(sceneready)
    {
             //updating points 
     for(const point of points)
     {
        const screenposition = point.position.clone();
        screenposition.project(camera)
        // console.log(screenposition.x)
        raycaster.setFromCamera(screenposition, camera)
        const intersects = raycaster.intersectObjects(scene.children,true)

        if(intersects.length===0)
        {
            point.element.classList.add('visible')
        }
        else
        {
            const intersectiondistance = intersects[0].distance
            const pointdistance = point.position.distanceTo(camera.position)

            if(intersectiondistance < pointdistance)
            {
                point.element.classList.remove('visible')                
            }
            else
            {
                point.element.classList.add('visible')
            }
        }

        const translateX =screenposition.x *sizes.width *0.2;
        const translateY = -screenposition.y *sizes.height *0.2;
        point.element.style.transform = `translate(${translateX}px,${translateY}px)`

     }

    }


     if(foxMixer)
     {
         foxMixer.update(deltaTime)
     }


     renderer.render(scene, camera)
     window.requestAnimationFrame(animate)
 }
 
 animate()